var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 52.917 52.917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".j-cls-1{fill:#444;}.j-cls-2{fill:none;stroke:#444;stroke-linejoin:round;stroke-width:10px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.10563 0 0 .12368 -.56919 -5.1611)",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    className: "j-cls-2",
    d: "m464 144v304h-320v-216h163.2a9.83 9.83 0 0 0 9.8-9.8v-80.4a9.83 9.83 0 0 0-9.8-9.8h-163.2v-68h224v64a16 16 0 0 0 16 16z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "j-cls-2",
    x1: 368,
    x2: 464,
    y1: 64,
    y2: 144
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j-cls-2",
    x: 37,
    y: 132,
    width: 280,
    height: 100,
    rx: 24.546,
    ry: 20.965
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    className: "j-cls-1",
    d: "m103.59 169.63v-6.36h20.41v27.66q0 7.32-3.72 11a13 13 0 0 1-9.54 3.66 17 17 0 0 1-12.48-5.16l4-5.58q4.08 3.9 8 3.9a6.58 6.58 0 0 0 4.71-1.86q1.95-1.86 1.95-5.58v-21.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j-cls-1",
    d: "m146.61 168.79a9.29 9.29 0 0 0-5.07 1.26 4.21 4.21 0 0 0-2 3.81 4.43 4.43 0 0 0 2 3.9q2 1.35 8.43 2.91t9.72 4.38q3.27 2.82 3.27 8.31a11 11 0 0 1-4.14 8.91q-4.14 3.42-10.86 3.42a25.51 25.51 0 0 1-17.46-6.78l4.44-5.34q6.36 5.52 13.2 5.52a9 9 0 0 0 5.43-1.47 4.6 4.6 0 0 0 2-3.9 4.38 4.38 0 0 0-1.89-3.78 19.89 19.89 0 0 0-6.51-2.46 58.32 58.32 0 0 1-7-2 15.83 15.83 0 0 1-4.27-2.48q-3.72-2.82-3.72-8.64a10.52 10.52 0 0 1 4.23-9 17 17 0 0 1 10.47-3.15 25.11 25.11 0 0 1 8 1.32 20.87 20.87 0 0 1 6.84 3.72l-3.78 5.34a14.31 14.31 0 0 0-5-2.76 19.42 19.42 0 0 0-6.33-1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j-cls-1",
    d: "m205.48 199.42a23 23 0 0 1-31.44 0 22 22 0 0 1 0-31 23 23 0 0 1 31.44 0 22 22 0 0 1 0 31zm-5.19-26.25a14.71 14.71 0 0 0-21.06 0 15.66 15.66 0 0 0 0 21.54 14.71 14.71 0 0 0 21.06 0 15.67 15.67 0 0 0 0-21.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j-cls-1",
    d: "m251.07 163.27h7.08v41.94h-7.68l-23.76-30.6v30.6h-7.08v-41.94h7.08l24.36 31.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j-cls-1",
    d: "m261 289.52q-9.7 0-9.7 9.73v37.05q0 12-10.32 14 10.32 1.88 10.32 13.83v40.13q0 4.44 2.27 6.15t8.68 1.71v15.88h-5.25q-21.27 0-21.27-22.54v-36.88q0-5.63-1.88-7.94t-5.94-2.31h-3.75v-15.88h3.75q4.07 0 5.94-2.39t1.88-8.2v-35.51q0-22.54 21.27-22.54h5.32v15.88a3.81 3.81 0 0 0-1.32-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j-cls-1",
    d: "m326.74 428h-5.32v-15.88q6.41 0 8.68-1.71t2.27-6.15v-40.12q0-12 10.32-13.83-10.32-2-10.32-14v-37.06q0-5.29-2.58-7.6a7.74 7.74 0 0 0-5.08-2.31h-0.47l-2.82 0.34v-15.87h5.32q21.27 0 21.27 22.54v35.52q0 5.81 1.88 8.2t5.94 2.39h3.75v15.88h-3.75q-4.07 0-5.94 2.31t-1.89 7.93v36.88q0 22.54-21.26 22.54z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j-cls-1",
    cx: 291.86,
    cy: 305.71,
    r: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j-cls-1",
    x: 285.86,
    y: 339.29,
    width: 12,
    height: 70,
    rx: 14.828,
    ry: 12.664
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/json.31eeb9459bc9065d336836595542c500.svg";
export { ForwardRef as ReactComponent };